<template>
  <span>
    <span v-if="serp.request().q">
      {{ serp.request().q }}
      <span v-if="serp.request().hl && serp.request().gl">({{
          serp.request().hl.toLowerCase()
        }} - {{ serp.request().gl.toUpperCase() }})</span>
      <span v-if="serp.request().google_ip"> - {{ serp.request().google_ip }}</span>
    </span>
    <span v-else>{{ $t('details') }}</span>
  </span>
</template>

<script>
export default {
  name: 'SerpDialogTitle',
  props: ['serp']
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"details": "Details of the results"
	},
	"es": {
		"details": "Detalles de los resultados"
	},
	"fr": {
		"details": "Détail des résultats"
	},
	"it": {
		"details": "Dettaglio dei risultati"
	},
	"pt": {
		"details": "Detalhe dos resultados"
	},
	"pl": {
		"details": "Szczegóły wyników"
	}
}
</i18n>
